// @flow
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';

import type { Params, Klasses, Klass, Period } from 'app/dataTypes/Klasses.types';
import { sortClasses } from 'app/common/lib/sort';
import SimpleDate from 'app/dataProviders/SimpleDate';

import type { Request } from '../../index';


const dateFormatApi: 'DD.MM.YYYY' = 'DD.MM.YYYY';
type DateApi = string

type ParamsApi = {
  student_id: number,
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId } = params;

  return [{
    student_id: parseInt(studentId, 10),
  }, null];
};

type PeriodApi = {
  start: DateApi,
  finish: DateApi,
  months: Array<number>,
}

type KlassApi = {
  id: number,
  title: string,
  latest: boolean,
  periodisation: string,
  schoolyear_id: number,
  schoolyear_title: string,
  schoolyear_periods: ?Array<PeriodApi>,
}

type ResultApi = {
  [id: string]: KlassApi,
  result: 'success',
}

export const convertResult = (res: ResultApi): Klasses => {
  const { result, ...klassesMap } = res;

  return pipe(
    values,
    map(({
      id,
      title,
      latest,
      periodisation,
      schoolyear_id: schoolyearId,
      schoolyear_title: schoolyearTitle,
      schoolyear_periods: schoolyearPeriods,
    }: KlassApi): Klass => ({
      id: String(id),
      title,
      latest,
      periodisation,
      schoolyearId: String(schoolyearId),
      schoolyearTitle: schoolyearTitle.replace(/-/, '–'),
      schoolyearPeriods: schoolyearPeriods
        ? map(({
          start,
          finish,
          // months, // deprecated
        }: PeriodApi): Period => ({
          start: new SimpleDate(start, dateFormatApi),
          finish: new SimpleDate(finish, dateFormatApi),
          // months,
        }), schoolyearPeriods)
        : null,
    })),
    sortClasses('up', prop('title')),
  )(klassesMap);
};

export const GET_KLASSES: Request<
  Params,
  Klasses,
  void
> = [
  'cabinet/dnevnik/klasses',
  'get',
  ['data'],
];
